var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRestaurantManagement = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.391,
    height: 21.365,
    viewBox: "0 0 22.391 21.365",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Restaurant_management",
    "data-name": "Restaurant management",
    transform: "translate(22502 7565.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4940",
    "data-name": "Path 4940",
    d: "M19.929,131.675a2.437,2.437,0,0,1-2.177-1.343,2.443,2.443,0,0,1-4.363,0,2.446,2.446,0,0,1-4.366,0,2.447,2.447,0,0,1-4.367,0,2.466,2.466,0,0,1-2.2,1.343,2.576,2.576,0,0,1-1.18-.3v9.068H0v2.41H22.364v-2.41h-1.2v-9.112a2.423,2.423,0,0,1-1.23.339Zm-8.71,1.318h7.455v3.69H11.22Zm-7.455,0h4.97v6.175H3.765Z",
    transform: "translate(-22502 -7686.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4941",
    "data-name": "Path 4941",
    d: "M297.31,116.619l0,0s0,0,0,0Z",
    transform: "translate(-22776.92 -7673.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4942",
    "data-name": "Path 4942",
    d: "M.333,116.622h0s0,0,0,0Z",
    transform: "translate(-22502.309 -7673.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4943",
    "data-name": "Path 4943",
    d: "M5.5,9.325l1.582-4.97h3.341l-.682,4.97h4.5l-.666-4.97h3.441l1.467,4.97h4.655l-2.4-4.97V.666H3.338v3.69l-2.5,4.97Z",
    transform: "translate(-22502.777 -7565.927)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRestaurantManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RestaurantManagement.763adb9c.svg";
export { ForwardRef as ReactComponent };